import { IConfig } from '../../config';
import { Store } from '../../state';
import { UserStreamMessage } from '../../types';
import { NbLogger } from '../../utils';
import { EventSourceLike, SSEClient } from './sseClient';

export class UserStreamClient extends SSEClient<UserStreamMessage> {
  constructor(
    readonly clientConstructor: () => EventSourceLike,
    protected readonly store: Store,
    protected logger: NbLogger,
    protected config: IConfig,
  ) {
    super(clientConstructor, store, logger, null);
  }
}
